export default "__VITE_ASSET__Bsh2RcTG__"